'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIFormControl from 'UIComponents/form/UIFormControl';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import withCommonFieldMap from 'DesignEditorsUI/components/shared/hoc/withCommonFieldMap';
import withPartials from 'ContentComponents/cmv2/decorators/withPartials';
import * as TagDefaultValueTypes from 'ContentUtils/enums/TagDefaultValueTypes';
import { DEFAULT, TAG_VALUE } from 'ContentUtils/constants/CustomWidgetFieldAttributes';
import { TAG } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { compose } from 'redux';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

class TagContentOptions extends PureComponent {
  constructor(...args) {
    super(...args);

    this.validateType = () => {
      const value = this.props.field[DEFAULT];
      const tagValue = this.props.field[TAG_VALUE];

      if (!value && !tagValue) {
        this.props.editField({
          [TAG_VALUE]: TagDefaultValueTypes.SLUG
        });
      } else if (value && typeof value === 'string' && tagValue !== TagDefaultValueTypes.SLUG && tagValue !== TagDefaultValueTypes.NAME) {
        this.props.editField({
          [TAG_VALUE]: TagDefaultValueTypes.SLUG
        });
      } else if (value && typeof value === 'number' && tagValue !== TagDefaultValueTypes.ID) {
        this.props.editField({
          [TAG_VALUE]: TagDefaultValueTypes.ID
        });
      } else if (value && typeof value === 'object' && tagValue !== TagDefaultValueTypes.ALL) {
        this.props.editField({
          [TAG_VALUE]: TagDefaultValueTypes.ALL
        });
      }
    };

    this.onFieldChange = (attr, value) => {
      this.props.editField({
        [attr]: value
      });
    };
  }

  componentDidMount() {
    this.validateType();
  }

  renderOptions() {
    // Filtering out `default` so it does not render and cause an i18n error
    // The default property is here because of a commonjs treeshaking hack
    // See https://git.hubteam.com/HubSpot/ContentUILib/blob/4742545431602b16d621226a568b0903f3f82e1a/ContentUtils/static-1.35373/js/enums/TagDefaultValueTypes.js#L7
    const tagTypesToRender = Object.keys(TagDefaultValueTypes).filter(type => type !== 'default');
    return tagTypesToRender.map(type => {
      return /*#__PURE__*/_jsxs(UIRadioInput, {
        name: type,
        size: "small",
        checked: type === this.props.field[TAG_VALUE],
        onChange: this.props.partial(this.onFieldChange, TAG_VALUE, type),
        disabled: this.props.readOnly,
        className: "p-bottom-2",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`tag.valueSelect.options.${type}.label`)
        }), /*#__PURE__*/_jsx(Small, {
          use: "help",
          className: "display-block",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(`tag.valueSelect.options.${type}.helpText`)
          })
        })]
      }, type);
    });
  }

  render() {
    const _this$props = this.props,
          {
      partial,
      field,
      componentsByType
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["partial", "field", "componentsByType"]);

    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('defaultLabels.tag')
        }),
        children: /*#__PURE__*/_jsx(SidebarInput, Object.assign({
          onFieldChange: partial(this.onFieldChange, DEFAULT),
          value: field[DEFAULT],
          required: false,
          componentsByType: componentsByType,
          type: TAG,
          inputComponent: componentsByType[TAG],
          tag_value: field[TAG_VALUE] || TagDefaultValueTypes.SLUG
        }, rest))
      }), /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('tag.valueSelect.label')
        }),
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('tag.valueSelect.tooltip')
        }),
        children: /*#__PURE__*/_jsx("div", {
          children: this.renderOptions()
        })
      })]
    });
  }

}

TagContentOptions.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  componentsByType: PropTypes.object.isRequired,
  partial: PropTypes.func.isRequired,
  readOnly: PropTypes.bool
};
export default compose(withCommonFieldMap, withPartials())(TagContentOptions);